// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// ** utils imports
import SessionStorage from '../../../utils/SessionStorage';

// initial states
const initialState = {
  user: {},
  token: null,
  forgotPasswordEmail: '',
  isForgotPassword: false,
  isOTPVerification: false,
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUserDetails: (state, { payload }) => {
      SessionStorage.setStringify('users', payload);

      return {
        ...state,
        users: payload,
      };
    },
    setToken: (state, { payload }) => {
      SessionStorage.set('token', payload);

      return {
        ...state,
        token: payload,
      };
    },
    setIsForgotPassword: (state, { payload }) => ({
      ...state,
      isForgotPassword: payload,
    }),
    setIsOTPVerification: (state, { payload }) => ({
      ...state,
      isOTPVerification: payload,
    }),
    setEmailForForgotPassword: (state, { payload }) => ({
      ...state,
      forgotPasswordEmail: payload,
    }),
    logout: () => {
      SessionStorage.remove('users');
      SessionStorage.remove('token');
      return initialState;
    },
  },
});

export const {
  setUserDetails,
  setToken,
  logout,
  setIsForgotPassword,
  setIsOTPVerification,
  setEmailForForgotPassword,
} = usersSlice.actions;

export default usersSlice.reducer;
